import { AppDispatch, RootState } from '..';
import { deliveryType, filterRangeType } from 'types';
import { getDeliveriesSuccess, onAddingDelivery, onFilterDeliveriesTotal, onLoadingDeliveries, onUpdatingDelivery } from '../reducers/delivery-reducer';

import { REACT_APP_MANAGE_SERVICE_ENDPOINT } from '../types';
import axios from 'axios';
import { headers } from '.';
import moment from 'moment';
import { notification } from 'utils';

export const filterDeliveryData = (selectedFilter: filterRangeType, custom_dates: Date[]) => async (dispatch: AppDispatch, getState: RootState) => {

    const { deliveries } = getState().deliveryReducer;

    let deliveredTotal: number = 0;
    let awaitApprovalTotal: number = 0;
    let approvedTotal: number = 0;
    let cancelledTotal: number = 0;
    let total: number = 0;

    switch (selectedFilter) {
        case 'week':
            {
                const startWeekDate = moment().startOf('week');
                const endWeekDate = moment().endOf('week');

                const weekDelivered = deliveries.filter((delivery: deliveryType) => moment(delivery.date).isSameOrAfter(startWeekDate) && moment(delivery?.date).isSameOrBefore(endWeekDate) && delivery.status === 'delivered');
                deliveredTotal = weekDelivered.reduce((previousValue: any, currentValue: any) => previousValue + currentValue.total, 0);

                const weekAwaitApproval = deliveries.filter((delivery: deliveryType) => moment(delivery.date).isSameOrAfter(startWeekDate) && moment(delivery?.date).isSameOrBefore(endWeekDate) && delivery.status === 'await approval');
                awaitApprovalTotal = weekAwaitApproval.reduce((previousValue: any, currentValue: any) => previousValue + currentValue.total, 0);

                const weekApproved = deliveries.filter((delivery: deliveryType) => moment(delivery.date).isSameOrAfter(startWeekDate) && moment(delivery?.date).isSameOrBefore(endWeekDate) && delivery.status === 'approved');
                approvedTotal = weekApproved.reduce((previousValue: any, currentValue: any) => previousValue + currentValue.total, 0);

                const weekCancelled = deliveries.filter((delivery: deliveryType) => moment(delivery.date).isSameOrAfter(startWeekDate) && moment(delivery?.date).isSameOrBefore(endWeekDate) && delivery.status === 'cancelled');
                cancelledTotal = weekCancelled.reduce((previousValue: any, currentValue: any) => previousValue + currentValue.total, 0);

                const weekDeliveries = deliveries.filter((delivery: deliveryType) => moment(delivery.date).isSameOrAfter(startWeekDate) && moment(delivery?.date).isSameOrBefore(endWeekDate));
                total = weekDeliveries.reduce((previousValue: any, currentValue: any) => previousValue + currentValue.total, 0);

                break;
            }
        case 'month':
            {
                const startMonthDate = moment().startOf('month').format('YYYY-MM-DD');
                const endMonthDate = moment().endOf('month').format('YYYY-MM-DD');

                const weekDelivered = deliveries.filter((delivery: deliveryType) => moment(delivery.date).format('YYYY-MM-DD') >= startMonthDate && moment(delivery?.date).format('YYYY-MM-DD') <= endMonthDate && delivery.status === 'delivered');
                deliveredTotal = weekDelivered.reduce((previousValue: any, currentValue: any) => previousValue + currentValue.total, 0);

                const weekAwaitApproval = deliveries.filter((delivery: deliveryType) => moment(delivery.date).format('YYYY-MM-DD') >= startMonthDate && moment(delivery?.date).format('YYYY-MM-DD') <= endMonthDate && delivery.status === 'await approval');
                awaitApprovalTotal = weekAwaitApproval.reduce((previousValue: any, currentValue: any) => previousValue + currentValue.total, 0);

                const weekApproved = deliveries.filter((delivery: deliveryType) => moment(delivery.date).format('YYYY-MM-DD') >= startMonthDate && moment(delivery?.date).format('YYYY-MM-DD') <= endMonthDate && delivery.status === 'approved');
                approvedTotal = weekApproved.reduce((previousValue: any, currentValue: any) => previousValue + currentValue.total, 0);

                const weekCancelled = deliveries.filter((delivery: deliveryType) => moment(delivery.date).format('YYYY-MM-DD') >= startMonthDate && moment(delivery?.date).format('YYYY-MM-DD') <= endMonthDate && delivery.status === 'cancelled');
                cancelledTotal = weekCancelled.reduce((previousValue: any, currentValue: any) => previousValue + currentValue.total, 0);

                const weekDeliveries = deliveries.filter((delivery: deliveryType) => moment(delivery.date).format('YYYY-MM-DD') >= startMonthDate && moment(delivery?.date).format('YYYY-MM-DD') <= endMonthDate);
                total = weekDeliveries.reduce((previousValue: any, currentValue: any) => previousValue + currentValue.total, 0);
                break;
            }
        case 'year':
            {
                const startYearDate = moment().startOf('year');
                const endYearDate = moment().endOf('year');

                const weekDelivered = deliveries.filter((delivery: deliveryType) => moment(delivery.date).isSameOrAfter(startYearDate) && moment(delivery?.date).isSameOrBefore(endYearDate) && delivery.status === 'delivered');
                deliveredTotal = weekDelivered.reduce((previousValue: any, currentValue: any) => previousValue + currentValue.total, 0);

                const weekAwaitApproval = deliveries.filter((delivery: deliveryType) => moment(delivery.date).isSameOrAfter(startYearDate) && moment(delivery?.date).isSameOrBefore(endYearDate) && delivery.status === 'await approval');
                awaitApprovalTotal = weekAwaitApproval.reduce((previousValue: any, currentValue: any) => previousValue + currentValue.total, 0);

                const weekApproved = deliveries.filter((delivery: deliveryType) => moment(delivery.date).isSameOrAfter(startYearDate) && moment(delivery?.date).isSameOrBefore(endYearDate) && delivery.status === 'approved');
                approvedTotal = weekApproved.reduce((previousValue: any, currentValue: any) => previousValue + currentValue.total, 0);

                const weekCancelled = deliveries.filter((delivery: deliveryType) => moment(delivery.date).isSameOrAfter(startYearDate) && moment(delivery?.date).isSameOrBefore(endYearDate) && delivery.status === 'cancelled');
                cancelledTotal = weekCancelled.reduce((previousValue: any, currentValue: any) => previousValue + currentValue.total, 0);

                const weekDeliveries = deliveries.filter((delivery: deliveryType) => moment(delivery.date).isSameOrAfter(startYearDate) && moment(delivery?.date).isSameOrBefore(endYearDate));
                total = weekDeliveries.reduce((previousValue: any, currentValue: any) => previousValue + currentValue.total, 0);
                break;
            }
        case 'custom':
            {
                const startCustomDate = moment(custom_dates[0]).format('YYYY-MM-DD');
                const endCustomDate = moment(custom_dates[1]).format('YYYY-MM-DD');

                const weekDelivered = deliveries.filter((delivery: deliveryType) => moment(delivery.date).format('YYYY-MM-DD') >= startCustomDate && moment(delivery?.date).format('YYYY-MM-DD') <= endCustomDate && delivery.status === 'delivered');
                deliveredTotal = weekDelivered.reduce((previousValue: any, currentValue: any) => previousValue + currentValue.total, 0);

                const weekAwaitApproval = deliveries.filter((delivery: deliveryType) => moment(delivery.date).format('YYYY-MM-DD') >= startCustomDate && moment(delivery?.date).format('YYYY-MM-DD') <= endCustomDate && delivery.status === 'await approval');
                awaitApprovalTotal = weekAwaitApproval.reduce((previousValue: any, currentValue: any) => previousValue + currentValue.total, 0);

                const weekApproved = deliveries.filter((delivery: deliveryType) => moment(delivery.date).format('YYYY-MM-DD') >= startCustomDate && moment(delivery?.date).format('YYYY-MM-DD') <= endCustomDate && delivery.status === 'approved');
                approvedTotal = weekApproved.reduce((previousValue: any, currentValue: any) => previousValue + currentValue.total, 0);

                const weekCancelled = deliveries.filter((delivery: deliveryType) => moment(delivery.date).format('YYYY-MM-DD') >= startCustomDate && moment(delivery?.date).format('YYYY-MM-DD') <= endCustomDate && delivery.status === 'cancelled');
                cancelledTotal = weekCancelled.reduce((previousValue: any, currentValue: any) => previousValue + currentValue.total, 0);

                const weekDeliveries = deliveries.filter((delivery: deliveryType) => moment(delivery.date).format('YYYY-MM-DD') >= startCustomDate && moment(delivery?.date).format('YYYY-MM-DD') <= endCustomDate);
                total = weekDeliveries.reduce((previousValue: any, currentValue: any) => previousValue + currentValue.total, 0);
                break;
            }
        default:
            deliveredTotal = 0;
            awaitApprovalTotal = 0;
            approvedTotal = 0;
            cancelledTotal = 0;
            total = 0;
            break;
    }

    dispatch(onFilterDeliveriesTotal({
        deliveredTotal,
        awaitApprovalTotal,
        approvedTotal,
        cancelledTotal,
        total
    }));

};

export const fetchDeliveries = () => async (dispatch: AppDispatch, getState: RootState) => {

    dispatch(onLoadingDeliveries(true));

    const { token } = getState().authReducer;
    const { company } = getState().companyReducer;
    const { company_id } = company;

    const { data } = await axios(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/deliveries/company/${company_id}`, headers(token));

    const { message, deliveries } = data;

    try {

        const _deliveries = deliveries?.reverse();

        dispatch(getDeliveriesSuccess(_deliveries));
        dispatch(onLoadingDeliveries(false));

    } catch (error: any) {

        dispatch(onLoadingDeliveries(false));
        notification('error', message || error.message);

    }
};

export const addDelivery = (values: deliveryType) => async (dispatch: AppDispatch, getState: RootState) => {

    dispatch(onAddingDelivery(true));

    const { deliveries } = getState().deliveryReducer;

    const { token } = getState().authReducer;
    const { company } = getState().companyReducer;
    const { company_id } = company;

    const { data } = await axios.post(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/delivery/admin/add`, { ...values, company_id }, headers(token));

    const { success, message, delivery } = data;

    try {

        dispatch(onAddingDelivery(false));
        notification(success ? 'success' : 'error', message);
        dispatch(getDeliveriesSuccess([
            ...deliveries,
            delivery
        ]));

    } catch (error: any) {

        dispatch(onAddingDelivery(false));
        notification('error', message || error.message);

    }

};

export const assignDeliveryDriver = (id: string, values: object) => async (dispatch: AppDispatch, getState: RootState) => {

    const { token } = getState().authReducer;

    const { data } = await axios.put(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/delivery/${id}/driver/update`, { ...values }, headers(token));

    const { success, message } = data;

    try {
        notification(success ? 'success' : 'error', message);
        dispatch(fetchDeliveries());
    } catch (error: any) {
        notification('error', message || error.message);
    }
};

export const assignDeliveryTruck = (id: string, values: object) => async (dispatch: AppDispatch, getState: RootState) => {

    const { token } = getState().authReducer;

    const { data } = await axios.put(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/delivery/${id}/truck/update`, { ...values }, headers(token));

    const { success, message } = data;

    try {
        notification(success ? 'success' : 'error', message);
        dispatch(fetchDeliveries());
    } catch (error: any) {
        notification('error', message || error.message);
    }
};

export const updateDeliveryStatus = (id: string, values: object) => async (dispatch: AppDispatch, getState: RootState) => {

    const { token } = getState().authReducer;

    const { data } = await axios.put(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/delivery/${id}/status/update`, { ...values }, headers(token));

    const { success, message } = data;

    try {
        notification(success ? 'success' : 'error', message);
        dispatch(fetchDeliveries());
    } catch (error: any) {
        notification('error', message || error.message);
    }
};

export const updateDelivery = (delivery: deliveryType) => async (dispatch: AppDispatch, getState: RootState) => {

    dispatch(onUpdatingDelivery(true));

    const { token } = getState().authReducer;

    const { data } = await axios.put(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/delivery/admin/${delivery?.delivery_id}/update`, { ...delivery }, headers(token));

    const { success, message } = data;

    try {

        notification(success ? 'success' : 'error', message);
        dispatch(fetchDeliveries());
        dispatch(onUpdatingDelivery(false));

    } catch (error: any) {

        notification('error', message || error.message);
        dispatch(onUpdatingDelivery(false));

    }
};

export const updateDeliveryPaymentStatus = (values: { delivery_id: string; payment_status: 'paid' | 'unpaid'; }) => async (dispatch: AppDispatch, getState: RootState) => {

    const { token } = getState().authReducer;

    const { data } = await axios.put(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/delivery/payment-status-update`, { ...values }, headers(token));

    const { success, message, error } = data;

    try {

        notification(success ? 'success' : 'error', message);
        dispatch(fetchDeliveries());

    } catch (err: any) {

        notification('error', message);
        console.error(error);
    }

};

export const updateDeliveryDateTime = (values: { delivery_id: string | any; date: string; time: string; }) => async (dispatch: AppDispatch, getState: RootState) => {

    const { token } = getState().authReducer;

    const { data } = await axios.put(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/delivery/date-time-update`, { ...values }, headers(token));

    const { success, message, error } = data;

    try {

        notification(success ? 'success' : 'error', message);
        dispatch(fetchDeliveries());

    } catch (err: any) {

        notification('error', message);
        console.error(error);
    }

};

export const updateDeliveryPaymentMethod = (values: { delivery_id: string; payment_method: 'cash' | 'card' | 'eft'; }) => async (dispatch: AppDispatch, getState: RootState) => {

    const { token } = getState().authReducer;

    const { data } = await axios.put(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/delivery/payment-method-update`, { ...values }, headers(token));

    const { success, message, error } = data;

    try {

        notification(success ? 'success' : 'error', message);
        dispatch(fetchDeliveries());

    } catch (err: any) {

        notification('error', message);
        console.error(error);
    }

};

export const deleteDelivery = (id: string) => async (dispatch: AppDispatch, getState: RootState) => {

    const { token } = getState().authReducer;

    const { data } = await axios.delete(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/delivery/${id}/delete`, headers(token));

    const { success, message, error } = data;

    try {

        notification(success ? 'success' : 'error', message);
        dispatch(fetchDeliveries());

    } catch (err) {
        console.log(error || err);
        notification('error', message);
    }
};